<ion-list class="ion-margin-horizontal-negative ion-padding-top-0">
  <ion-item-group>
    <ion-item-divider sticky>
      <ion-label>Ficheros importados</ion-label>
    </ion-item-divider>

    @for (batchImport of batchImports(); track batchImport.id) {
      <ion-item>
        <ion-grid>
          <ion-row>
            <ion-col
              class="ion-align-self-center"
              size="4"
              size-lg="4"
            >
              <p>
                {{ batchImport.startedAt | date: 'dd/MM/yyyy HH:mm' }}
              </p>
            </ion-col>
            <ion-col
              class="ion-align-self-center"
              size="4"
              size-lg="4"
            >
              <p>
                {{ batchImport.finishedAt | date: 'dd/MM/yyyy HH:mm' }}
              </p>
            </ion-col>
            <ion-col
              class="ion-align-self-center"
              size="1"
              size-lg="1"
            >
              <p>{{ batchImport.totalRows }}</p>
            </ion-col>
            <ion-col
              class="ion-text-end ion-align-self-center"
              size="3"
              size-lg="3"
            >
              @if (batchImport.errorCount) {
                <ion-button
                  fill="outline"
                  [routerLink]="detailRoute() + '/' + batchImport.id"
                  routerLinkActive="active"
                  routerDirection="root"
                >
                  <ion-icon
                    aria-hidden="true"
                    slot="start"
                    src="../assets/material-symbols/warning_24dp.svg"
                  ></ion-icon>
                  Revisar errores
                </ion-button>
              }
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    } @empty {
      <ion-item>
        <ion-label>
          <p class="fs-sm ion-text-center">No hay importaciones de excel</p>
        </ion-label>
      </ion-item>
    }
  </ion-item-group>
</ion-list>
